<div class="verification-main-container">
  <div class="verification-up-row">
    <div class="up-row-left">E-Mail-Adresse verifizieren</div>
    <div class="up-row-right" (click)="closeDialog()">
      <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
    </div>
  </div>
  <div class="icon-container">
    <image-loader-utils url="mail" extraClasses="main-svg"></image-loader-utils>
  </div>
  <div class="verification-sub-text">
    Bitte bestätige deine E-Mail Adresse indem du auf den Link in der E-Mail Klickst ,die du von uns erhalten hast.Schaue unbedingt auch im Spam-Ordner nach, falls du die E-Mail
    nicht im Posteingang finden kannst.
  </div>
</div>
